<template>
  <MissionSearchPage widget :search="{ organization: useRoute().params.id }" />
</template>
